import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";
import PageHero from "@/components/public/PageHero";
import api from "@/lib/api";

export default function Education() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("All");

  useEffect(() => { api.get("/content/education?published_only=true").then((r) => setItems(r.data)).catch(() => {}); }, []);

  const cats = ["All", ...Array.from(new Set(items.map((i) => i.category).filter(Boolean)))];
  const filtered = items.filter((i) => (cat === "All" || i.category === cat) && i.title?.toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <PageHero overline="Learn" title="Education Center" subtitle="Structured guides to build and sharpen your trading edge." />
      <section className="py-16 sm:py-24 bg-white">
        <div className="cb-container">
          <div className="flex flex-col sm:flex-row gap-4 mb-8">
            <div className="relative flex-1">
              <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
              <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search guides..." className="w-full bg-white border border-slate-200 rounded pl-10 pr-4 py-2.5 text-sm text-[#0B1D40] placeholder-slate-500 focus:border-[#D8AE4E]/50 outline-none" data-testid="education-search" />
            </div>
            <div className="flex flex-wrap gap-2">
              {cats.map((c) => (
                <button key={c} onClick={() => setCat(c)} className={`px-3 py-2 text-sm rounded transition-colors ${cat === c ? "btn-gold" : "text-slate-700 border border-slate-200 hover:border-[#D8AE4E]/50"}`} data-testid={`education-cat-${c.toLowerCase().replace(/\s+/g, "-")}`}>{c}</button>
              ))}
            </div>
          </div>
          {filtered.length === 0 ? <p className="text-slate-500">No guides found.</p> : (
            <div className="grid md:grid-cols-3 gap-6">
              {filtered.map((e) => (
                <div key={e.id} className="cb-card p-6" data-testid={`education-item-${e.id}`}>
                  <div className="flex items-center gap-2 mb-3">
                    {e.level && <span className="text-xs px-2 py-1 rounded border border-slate-200 text-slate-700">{e.level}</span>}
                    {e.read_time && <span className="text-xs text-slate-500 font-mono">{e.read_time}</span>}
                  </div>
                  <h3 className="font-serif text-xl text-[#0B1D40] mb-2">{e.title}</h3>
                  <p className="text-slate-500 text-sm leading-relaxed">{e.excerpt}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
